import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';
import classname from 'classnames';

import { withTranslation, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

const Navbar = (props) => {
  const [dashboard, setDashboard] = useState(false);
  const [medicines, setMedicines] = useState(false);
  const [manufacturers, setManufacturers] = useState(false);
  const [categories, setCategories] = useState(false);
  const [ingredients, setIngredients] = useState(false);
  const [inventory, setInventory] = useState(false);
  const [regulatory, setRegulatory] = useState(false);
  const [item, setitem] = useState(false);

  const { i18n } = useTranslation();
  const isUrdu = i18n.language === 'ur';

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById('navigation');
    var items = ul.getElementsByTagName('a');
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains('active')) {
        item.classList.remove('active');
      }
      if (parent && parent.classList.contains('active')) {
        parent.classList.remove('active');
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add('active');
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add('active');
      const parent2 = parent.parentElement;
      parent2?.classList.add('active');
      const parent3 = parent2?.parentElement;
      parent3?.classList.add('active');
      const parent4 = parent3?.parentElement;
      parent4?.classList.add('active');
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav className="navbar navbar-light navbar-expand-lg topnav-menu" id="navigation">
            <Collapse isOpen={props.leftMenu} className="navbar-collapse" id="topnav-menu-content">
              <ul className={`navbar-nav ${isUrdu ? 'text-end fw-bold' : ''}`}>
                {/* File */}
                <li className="nav-item">
                  <Link to="/file" className="nav-link">
                    File
                  </Link>
                </li>

                {/* Purchase */}
                <li className="nav-item">
                  <Link to="/purchases/invoices" className="nav-link">
                    Purchases
                  </Link>
                </li>

                {/* Medicines */}
                <li className="nav-item">
                  <Link to="/medicines" className="nav-link">
                    Medicines
                  </Link>
                </li>

                {/* Sales */}
                <li className="nav-item">
                  <Link to="/sales/invoices" className="nav-link">
                    Sales
                  </Link>
                </li>

                {/* Reports */}
                <li className="nav-item">
                  <Link to="/reports" className="nav-link">
                    Reports
                  </Link>
                </li>

                {/* Basic Data */}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      setdashboard(!dashboard); // toggle Basic Data dropdown
                    }}
                  >
                    Basic Data <div className="arrow-down"></div>
                  </Link>
                  <div className={classname('dropdown-menu', { show: dashboard })}>
                    <Link to="/basic-data/customer" className="dropdown-item">
                      Customer
                    </Link>
                    <Link to="/basic-data/supplier" className="dropdown-item">
                      Supplier
                    </Link>

                    {/* Nested dropdown for Item */}
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={(e) => {
                          e.preventDefault();
                          setitem(!item); // You need to add `const [item, setitem] = useState(false);` in your component
                        }}
                      >
                        Item <div className="arrow-down"></div>
                      </Link>
                      <div className={classname('dropdown-menu', { show: item })}>
                        <Link to="/medicines/add" className="dropdown-item">
                          Add new Item
                        </Link>
                        <Link to="/basic-data/item/item2" className="dropdown-item">
                          Item 2
                        </Link>
                        <Link to="/basic-data/item/item3" className="dropdown-item">
                          Item 3
                        </Link>
                        <Link to="/basic-data/item/item4" className="dropdown-item">
                          Item 4
                        </Link>
                        <Link to="/basic-data/item/item5" className="dropdown-item">
                          Item 5
                        </Link>
                        <Link to="/basic-data/item/item6" className="dropdown-item">
                          Item 6
                        </Link>
                        <Link to="/basic-data/item/item7" className="dropdown-item">
                          Item 7
                        </Link>
                      </div>
                    </div>

                    <Link to="/basic-data/sale-template" className="dropdown-item">
                      Sale Template
                    </Link>
                  </div>
                </li>

                {/* Maintenance */}
                <li className="nav-item">
                  <Link to="/maintenance" className="nav-link">
                    Maintenance
                  </Link>
                </li>

                {/* Window */}
                <li className="nav-item">
                  <Link to="/window" className="nav-link">
                    Window
                  </Link>
                </li>

                {/* Help */}
                <li className="nav-item">
                  <Link to="/help" className="nav-link">
                    Help
                  </Link>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  return {};
};

export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Navbar)));
